import { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";

// Loads media. Images are fetched as a blob (credentialed). Video/audio use a direct
// same-origin URL so the browser can stream and seek via HTTP range requests.
export default function AuthMedia({ id, kind = "image", className = "", alt = "", controls = true, testId }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  const streaming = kind === "video" || kind === "audio";

  useEffect(() => {
    if (streaming) return; // direct src, no blob needed
    let active = true;
    let objectUrl = null;
    setErr(false);
    setUrl(null);
    if (!id) return;
    api
      .get(`/files/${id}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => active && setErr(true));
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [id, streaming]);

  if (kind === "video") {
    return <video data-testid={testId} src={fileUrl(id)} className={className} controls={controls} playsInline preload="metadata" />;
  }
  if (kind === "audio") {
    return <audio data-testid={testId} src={fileUrl(id)} className={className} controls={controls} preload="metadata" />;
  }
  if (err) {
    return (
      <div className={`flex items-center justify-center bg-muted text-muted-foreground text-xs ${className}`}>
        unavailable
      </div>
    );
  }
  if (!url) {
    return <div className={`animate-pulse bg-muted ${className}`} />;
  }
  return <img data-testid={testId} src={url} alt={alt} className={className} />;
}
